import { render } from "./index.vue?vue&type=template&id=5c324ef4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5c324ef4&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c324ef4"]])

export default __exports__